import { MenuItem as ChakraMenuItem, Text } from '@chakra-ui/react'
import React from 'react'
import { useThemeColors } from 'hooks/useThemeColors'

type MenuItemProps = {
  onClick: () => void
  label: string
  isActive: boolean
} & React.ComponentProps<typeof ChakraMenuItem>

export const MenuItem = ({ onClick, label, isActive, ...rest }: MenuItemProps) => {
  const COLORS = useThemeColors()

  return (
    <ChakraMenuItem onClick={onClick} {...rest}>
      <Text variant="caption2medium" color={isActive ? COLORS.zircuitPrimary : COLORS.grey02}>
        {label}
      </Text>
    </ChakraMenuItem>
  )
}
